import { Model } from "@vuex-orm/core";
import config from "../configs/Media";
import Mandate from "./Mandate";

export default class Media extends Model {
  static get entity() {
    return "media";
  }
  static fields() {
    return {
      id: this.attr(null),
      filename: this.attr(null),
      label: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),

      file_path: this.attr(null),
      url: this.attr(null),
      resolution_id: this.attr(null),
      meeting_has_resolution_id: this.attr(null),
      meeting_id: this.attr(null),
      signed_pv_meeting_id: this.attr(null),
      signed_presence_meeting_id: this.attr(null),
      agency_id: this.attr(null),
      position: this.attr(null),
      additional_invitation_media_meeting_id: this.attr(null),
      presence_signature_mandate_id: this.attr(null),
      presence_signature_contact_id: this.attr(null),

      individual_file_invitation_mandate_id: this.attr(null),
      individual_file_pv_mandate_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
